import { t } from '@bms2/shared';
import { Icon } from '../../components/Icon';
import styles from './CallList.module.css';

/**
 * 🔒 Play (decision 11860): the recording's address at the provider, opened in a new tab, because the shell has no
 * audio control of its own. 🔨 The click never reaches the row, so Play does not also open the call.
 */
export function PlayLink({ url }: { url: string }) {
  return (
    <a className={styles.play} href={url} target="_blank" rel="noreferrer noopener" data-call-play="true" onClick={(event) => event.stopPropagation()}>
      <Icon meaning="playRecording" />
      {t('phonePages.voicemail.play')}
    </a>
  );
}
